import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const cartIdKey = 'cartId';
export const viewedSalesArticleKey = 'viewed';

@Injectable({ providedIn: 'root' })
export class WebStorageService {
  platformId = inject(PLATFORM_ID);

  set(key: string, value: any) {
    this.setString(key, JSON.stringify(value));
  }

  get<T>(key: string): T {
    if (isPlatformBrowser(this.platformId)) {
      const str = this.getString(key);
      return JSON.parse(str) as T;
    }
  }

  setString(key: string, value: string) {
    if (isPlatformBrowser(this.platformId)) {
      window.localStorage.setItem(key, value);
    }
  }

  getString(key: string): string {
    if (isPlatformBrowser(this.platformId)) {
      return window.localStorage.getItem(key);
    }
  }

  remove(key: string) {
    if (isPlatformBrowser(this.platformId)) {
      window.localStorage.removeItem(key);
    }
  }
}
